/* eslint-disable react/require-default-props */
import React from 'react'

import PropTypes from 'prop-types'
import { useConnect } from 'redux-bundler-hook'

import { Person as PersonIcon } from '@mui/icons-material'
import { Avatar } from '@mui/material'

import { idPropType } from '~/src/Lib/PropTypes'
import { initials, useFilestackURL } from '~/src/Lib/Utils'

import BaseWidget from './Base'

export const WidgetPerson = props => {
  const { title, person, Icon, ...passthru } = props

  return (
    <BaseWidget
      {...passthru}
      title={person?.fullName || title}
      Icon={Icon}
    />
  )
}

WidgetPerson.propTypes = {
  person: PropTypes.shape({ fullName: PropTypes.string.isRequired }),
  Icon: PropTypes.elementType,
  title: PropTypes.string,
}
WidgetPerson.defaultProps = {
  person: null,
  Icon: PersonIcon,
  title: '',
}
WidgetPerson.displayName = 'Widget/Person'

const WidgetPersonWrapper = props => {
  let { user: userId, membership: membershipId } = props
  const { facilityMemberships: memberships, users } = useConnect(
    'selectFacilityMemberships',
    'selectUsers'
  )
  const filestackUrl = useFilestackURL()
  if (!membershipId) {
    membershipId = Object.values(memberships).find(m => m.user === userId)?.id
  }

  const { [membershipId]: membership } = memberships

  if (!userId) {
    userId = membership?.user
  }
  const { [userId]: user } = users
  const userInitials = user ? initials(user.fullName) : 'N/A'
  const Icon = props.Icon ?? (
    membership?.photo?.handle ? (
      () => (
        <Avatar
          src={filestackUrl(membership.photo, ['resize=width:32,height:32'])}
          alt={userInitials}
        />
      )
    ) : () => <Avatar>{userInitials}</Avatar>
  )
  return <WidgetPerson {...props} person={user} Icon={Icon} />
}
WidgetPersonWrapper.propTypes = {
  user: idPropType.nullable,
  membership: idPropType.nullable,
  Icon: PropTypes.elementType,
}
WidgetPersonWrapper.defaultProps = {
  user: null,
  membership: null,
  Icon: null,
}

export default React.memo(WidgetPersonWrapper)
